export const getSearchParams = (searchParamName, unitName) => {
    const params = new URLSearchParams();
    params.set(searchParamName, unitName);
    return params.toString();
};
